/* global REACT_APP_NODE_VERSION */
import React from 'react';

function Footer() {
  return (
    <footer
      style={{
        marginTop: '40px',
        padding: '12px',
        textAlign: 'center',
        fontSize: '0.8em',
        opacity: 0.6,
      }}
    >
      {REACT_APP_NODE_VERSION}
    </footer>
  );
}

export default Footer;
